/**
 * Created by Darius on 2017.04.02.
 */
const defaultState = {
    appName: 'Web Admin',
    token: null,
    viewChangeCounter: 0,
    hasError: false,
    showSideMenu: false
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'APP_LOAD':
            return {
                ...state,
                token: action.token || null,
                appLoaded: true,
                currentUser: action.payload ? action.payload.user : null
            };
        case 'OPEN_SIDE_MENU':
            return { ...state, showSideMenu: action.payload };
        case 'REDIRECT':
            return { ...state, redirectTo: null };
        case 'LOGOUT':
            return { ...state, redirectTo: '/login', token: null, currentUser: null };
        case 'ARTICLE_SUBMITTED':
            const redirectUrl = `article/${action.payload.article.slug}`;
            return { ...state, redirectTo: redirectUrl };
        case 'LOGIN':
            return {
                ...state,
                redirectTo: action.error ? null : '/',
                token: action.error ? null : window.localStorage.getItem('token'),
                currentUser: action.error ? null : "user"
            };
        case 'DELETE_ROLE':
            return {
                ...state,
                hasMessage: true,
                message: 'Saved successfully',
                redirectTo: action.error ? undefined : '/roles'
            };
        case 'DELETE_ARTICLE':
            return { ...state, redirectTo: '/' };
        case 'SUBMIT_ROLE':
            return {
                ...state,
                hasMessage: true,
                message: 'Saved successfully',
                redirectTo: action.error ? undefined : '/roles'
            };
        case 'ON_ERROR':
            return {
                ...state,
                hasError: action.hasError,
                errorObj: action.payload,
            };
        case 'CLOSE_ERROR':
            return {
                ...state,
                hasError: action.payload
            };
        case 'NOTIFY_USER':
            return {
                ...state,
                hasMessage: true,
                message: action.payload,
            };
        case 'SUBMIT_FEED_SOURCE':
            return {
                ...state,
                hasMessage: true,
                message: 'Saved successfully',
                redirectTo: action.error ? undefined : '/feed-sources'
            };
        case 'SUBMIT_MEMBER':
            return {
                ...state,
                hasMessage: true,
                message: 'Saved successfully',
                redirectTo: action.error ? undefined : '/members'
            };
        case 'SUBMIT_TEMPLATE':
            return {
                ...state,
                hasMessage: true,
                message: 'Saved successfully',
                redirectTo: action.error ? undefined : '/templates'
            };
        case 'SEND_TEMPLATE':
            return {
                ...state,
                hasMessage: true,
                message: 'Send successfully'
            };
        case 'DELETE_TEMPLATE':
            return {
                ...state,
                hasMessage: true,
                message: 'Deleted successfully',
                redirectTo: action.error ? undefined : '/templates'
            };
        case 'NOTIFY_USER_CLOSE':
            return {
                ...state,
                hasMessage: action.payload,
                message: ""
            };
        case 'TEMPLATES_PAGE_UNLOADED':
        case 'TEMPLATE_PAGE_UNLOADED':
        case 'ROLES_PAGE_UNLOADED':
        case 'ROLE_PAGE_UNLOADED':
        case 'MEMBERS_PAGE_UNLOADED':
        case 'MEMBER_PAGE_UNLOADED':
        case 'HOME_PAGE_UNLOADED':
        case 'PROFILE_PAGE_UNLOADED':
        case 'PROFILE_FAVORITES_PAGE_UNLOADED':
        case 'SETTINGS_PAGE_UNLOADED':
        case 'LOGIN_PAGE_UNLOADED':
        case 'REGISTER_PAGE_UNLOADED':
            return { ...state, viewChangeCounter: state.viewChangeCounter + 1 };
    }

    return state;
};